import type { ChartContent } from "./contentItemSchemas";
import {
  chartContentFieldsSchema,
  parseChartContentFromFields,
  parseWithRecord,
} from "./schemas";

export const parseChartContent = (
  item: unknown,
  formLabel?: string,
): ChartContent => {
  const parsed = parseWithRecord(item, chartContentFieldsSchema);
  return parseChartContentFromFields(parsed, formLabel);
};
